import Persist from '@/models/Persist'
import AffiliateHelper from '@/helper/AffiliateHelper'

class Multiplier extends Persist {
  constructor () {
    super()

    this.api = {
      url: `${process.env.VUE_APP_API_DOMAIN}`,
      endpoints: {
        save: '/multipliers',
        update: '/multipliers',
        delete: '/multipliers'
      }
    }

    this.attrs = {}
  }

  static validators () {
    return {
      affiliate_id: [
        v => !!v || 'Field is required'
      ],
      value: [
        v => !!v || 'Field is required'
      ]
    }
  }

  static parserFrom (data) {
    let object = new Multiplier()
    let attrs = {}

    attrs._id = (data.hasOwnProperty('_id')) ? data._id : ''
    attrs.affiliate_id = (data.hasOwnProperty('affiliate_id')) ? data.affiliate_id : ''
    attrs.affiliate_name = (data.hasOwnProperty('affiliate_id')) ? AffiliateHelper.getAffiliate(data.affiliate_id).name : ''
    attrs.value = (data.hasOwnProperty('value')) ? data.value : ''
    attrs.created_at = (data.hasOwnProperty('createdAt')) ? data.createdAt : ''
    attrs.updated_at = (data.hasOwnProperty('updatedAt')) ? data.updatedAt : ''

    object.attrs = attrs

    return object
  }

  preCreate () {
    delete this.attrs.affiliate_name
  }

  preUpdate () {
    delete this.attrs.affiliate_name
  }
}

export default Multiplier
